import React, { Component } from "react";
import ItepFacilityDescription from "./ItepFacilityDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { Menu } from "antd";
import { Container } from "@mui/material";

export const menu = [
  {
    title: "About Course",
    link: "about-course",
    type: "content",
    code: "ITEP_ABOUT",
  },
  {
    title: "Management Committee",
    link: "management-committee",
    type: "file",
    code: "ITEP_COMMITTEE",
  },
  {
    title: "Program & Intake",
    link: "program-intake",
    type: "content",
    code: "ITEP_PROGRAM_INTAKE",
  },
  {
    title: "Faculty & Administrative Staff",
    link: "faculty-staff",
    type: "file",
    code: "ITEP_FACULTY_STAFF",
  },
  {
    title: "NCTE",
    link: "ncte",
    type: "file",
    code: "ITEP_NCTE",
  },
  {
    title: "Faculty Left or Join",
    link: "faculty-left-join",
    type: "file",
    code: "ITEP_FACULTY_LEFT_JOIN",
  },
  {
    title: "Student Enrollment",
    link: "student-enrollment",
    type: "file",
    code: "ITEP_STUDENT_ENROLLMENT",
  },
  {
    title: "Land Documents",
    link: "land-document",
    type: "file",
    code: "ITEP_LAND_DOCUMENTS",
  },
  {
    title: "Library",
    link: "library",
    type: "content",
    code: "ITEP_LIBRARY",
  },
  {
    title: "Fee Structure",
    link: "fee-structure",
    type: "content",
    code: "ITEP_FEES_STRUCTURE",
  },
  {
    title: "Relevant Document",
    link: "relevant-document",
    type: "file",
    code: "ITEP_RELEVANT_DOCUMENT",
  },
  {
    title: "Infrastructure Facilities",
    link: "infrastructure-facilities",
    type: "content",
    code: "ITEP_INFRASTRUCTURE",
  },
];

class ItepFacility extends Component {
  state = {
    link: "",
    code: "",
    title: "",
    type: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    const ll = menu.find((el) => el.link == link);
    this.setState({
      link: link,
      code: ll.code,
      title: ll.title,
      type: ll.type,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      const ll = menu.find((el) => el.link == link);
      this.setState({
        link: link,
        code: ll.code,
        title: ll.title,
        type: ll.type,
      });
    }
  }

  render() {
    return (
      <div>
        <BreadCrumbOwn title="Integrated Teacher Education Programme" hideBottomDiv={true}>
          <div style={{ background: "#001529" }}>
            <Menu
              theme="dark"
              mode="horizontal"
              selectedKeys={[this.state.link || "about-course"]}
              onClick={({ key }) => {
                if (
                  this.props.history &&
                  typeof this.props.history.push === "function"
                ) {
                  this.props.history.push(`/itep/${key}`);
                }
                this.setState({ link: key });
              }}
            >
              {menu.map((m, i) => (
                <Menu.Item key={m.link} value={m.link}>
                  {m.title}
                </Menu.Item>
              ))}
            </Menu>
          </div>
        </BreadCrumbOwn>

        

        <ItepFacilityDescription
          type={this.state.type}
          code={this.state.code}
          title={this.state.title}
        />
      </div>
    );
  }
}

export default ItepFacility;
